import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Product } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { ProductList } from '../product-list/product-list';

@Component({
  selector: 'app-product-recommended-list',
  imports: [ProductList],
  templateUrl: './product-recommended-list.html',
  styleUrl: './product-recommended-list.scss',
})
export class ProductRecommendedList implements OnChanges {
  @Input({ required: true }) no: string = '';
  loading: boolean = false;
  products: Product[] = [];
  constructor(private productApi: ProductApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.findProductRecommended();
  }

  @HostBinding('class.empty')
  get isEmpty() {
    return !this.loading && this.products.length === 0;
  }

  async findProductRecommended() {
    try {
      this.loading = true;
      this.products = await this.productApi.findProductRecommended(this.no, {
        limit: 8,
      });
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
